export const SCREEN_SM = 576
export const SCREEN_MD = 768
export const SCREEN_LG = 992
export const SCREEN_XL = 1200
export const SCREEN_XXL = 1400
